import { withNamespace } from "@/i18n/lazy-route"

/** The staff overview (LLD §9.14, Task 6.1), with the `adminOverview` namespace. */
export const AdminOverviewScreen = withNamespace(
  "adminOverview",
  () => import("./screens/AdminOverviewScreen"),
  {
    en: () => import("@/i18n/locales/en/adminOverview.json"),
    fr: () => import("@/i18n/locales/fr/adminOverview.json"),
  },
)
